import { getDefaultConfig } from '@rainbow-me/rainbowkit'
import {
  coinbaseWallet,
  coreWallet,
  injectedWallet,
  rabbyWallet,
  rainbowWallet,
  safeWallet,
  trustWallet,
  walletConnectWallet,
} from '@rainbow-me/rainbowkit/wallets'
import { avalanche, avalancheFuji } from 'viem/chains'

const GGPVaultWalletConnectId = '7f76c5d63872451067a26cdc31f5a6f7'

export const config = getDefaultConfig({
  appName: 'SeaFi Vaults',
  chains: [avalanche, avalancheFuji],
  wallets: [
    {
      groupName: 'Recommended',
      wallets: [coreWallet, rabbyWallet, walletConnectWallet, safeWallet],
    },
    {
      groupName: 'Others',
      wallets: [coinbaseWallet, trustWallet, rainbowWallet, injectedWallet],
    },
  ],
  projectId: GGPVaultWalletConnectId,
})
